import typeList from "../data/typeList";

export default {
    data() {
        return {
            typeList,
            type: 0,
            url: '',
            phone: '',
            content: ''
        }
    },

    watch: {

    },

    created() {

    },

    methods: {
        submitInfo() {
            if(this.type === 0) {
                this.$message.error('请选择问题类型');
                return;
            }
            if(!this.url.trim()) {
                this.$message.error('请输入页面地址');
                return;
            }
            if(!this.phone.trim()) {
                this.$message.error('请输入联系方式');
                return;
            }
            if(!this.content.trim()) {
                this.$message.error('请输入反馈内容');
                return;
            }
            if(!this.$getToken()) {
                this.$message.error('登录后才可以进行意见反馈哦！');
                return;
            }
            this.$post('api.php/Home/userLeave',{
                token: this.$getToken(),
                type: this.type,
                page_url: this.url,
                contact: this.phone,
                content: this.content
            }).then(res => {
                this.$message.info(res.info)
                if(res.status == 1) {
                    this.type = 0;
                    this.url = '';
                    this.phone = '';
                    this.content = '';
                }
            })
        }
    }
}
